import React, { memo, useMemo } from "react";
import Reading from "../sections/Reading";
import Listening from "../sections/Listening";
import Writing from "../sections/Writing";
import ReadingIntro from "../exam-intro/ReadingIntro";
import ListeningIntro from "../exam-intro/ListeningIntro";
import WritingIntro from "../exam-intro/WritingIntro";
import ExamExpired from "../errors/ExamExpired";
import ExamFinish from "../errors/ExamFinish";
import ExamNotStarted from "../errors/ExamNotStarted";
import NotFound from "../errors/NotFound";
import DemoExamFinished from "../errors/DemoExamFinished";
import PracticeExamFinished from "../errors/PracticeExamFinished";
import UnknownException from "../errors/UnknownException";
import Loading from "../layout/Loading";

const ExamContent = ({
  activeView,
  showExam,
  timeLeft,
  setShowExam,
  isDemoExam,
}) => {
  const handleStartExam = () => setShowExam(true);
  // console.log("ACTIVE STAGE", activeView);

  const stageComponents = useMemo(
    () => ({
      listeningIntro: (
        <ListeningIntro
          timeLeft={timeLeft}
          onStart={handleStartExam}
          isDemoExam={isDemoExam}
        />
      ),
      listening: showExam ? (
        <Listening />
      ) : (
        <ListeningIntro
          timeLeft={0}
          onStart={handleStartExam}
          isDemoExam={isDemoExam}
        />
      ),
      readingIntro: (
        <ReadingIntro timeLeft={timeLeft} onStart={handleStartExam} />
      ),
      reading: showExam ? (
        <Reading />
      ) : (
        <ReadingIntro timeLeft={0} onStart={handleStartExam} />
      ),
      writingIntro: (
        <WritingIntro timeLeft={timeLeft} onStart={handleStartExam} />
      ),
      writing: showExam ? (
        <Writing />
      ) : (
        <WritingIntro timeLeft={0} onStart={handleStartExam} />
      ),
      examNotStarted: <ExamNotStarted />,
      examFinish: <ExamFinish />,
      examExpired: <ExamExpired />,
      demoFinished: <DemoExamFinished />,
      practiceFinished: <PracticeExamFinished />,
      notFound: <NotFound />,
      unknownException: <UnknownException />,
    }),
    [timeLeft, showExam]
  );

  return stageComponents[activeView] || <Loading />;
};

export default memo(ExamContent);
